import { makeAutoObservable } from 'mobx';
import { OverviewDto } from '../../../../defs/api';
import { PersonalAssetOverviewMobxDto } from '../personal-assets/personal-asset-overview-mobx-dto';
import { InvestownOverviewMobxDto } from '../personal-assets/investown-overview-mobx-dto';

export class OverviewMobxDto implements OverviewDto {
    dateFrom: string = '';

    lastUpdated: string = '';

    portfolioValue: number = 0;

    invested: number = 0;

    investmentPeriod: number = 0;

    averageInvestment: number = 0;

    unrealizedProfit: number = 0;

    unrealizedProfitPercentage: number = 0;

    todayUnrealizedProfit: number = 0;

    todayUnrealizedProfitPercentage: number = 0;

    simpleReturn: number = 0;

    moneyWeightedReturn: number = 0;

    timeWeightedReturn: number = 0;

    realizedProfit: number = 0;

    realizedProfitPercentage: number = 0;

    dividends: number = 0;

    dividendsNextYearPrediction: number = 0;

    dividendsYield: number = 0;

    dividendsYieldOnCost: number = 0;

    fees: number = 0;

    feesPercentage: number = 0;

    rateImpact: number = 0;

    totalPortfolioValue: number = 0;

    isRecalculating: boolean = false;

    personalAssetOverview?: PersonalAssetOverviewMobxDto;

    investownAssetOverview?: InvestownOverviewMobxDto;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: OverviewDto): OverviewMobxDto {
        const mobxDto = new OverviewMobxDto();
        return Object.assign(mobxDto, dto, {
            personalAssetOverview: dto.personalAssetOverview
                ? PersonalAssetOverviewMobxDto.create(dto.personalAssetOverview)
                : undefined,
        });
    }

    static createFromArray(dtos: OverviewDto[]): OverviewMobxDto[] {
        return dtos.map((dto) => OverviewMobxDto.create(dto));
    }
}
